<template>
  <div class="statistical-performance">
    <div class="handle-header">
      <div style="display:flex;">
        <mk-select
          v-model="dayUnitIndex"
          class="select-item"
          width="120"
        >
          <mk-option
            v-for="(item,index) in dayUnits"
            :key="index"
            :label="item.label"
            :value="item.value"
          >
          </mk-option>
        </mk-select>
        <mk-date-picker
          v-model="date"
          class="select-item statistical-performance-date-picker"
          :type="dayUnitType"
          :format="dateFormat"
          :value-format="valueFormat"
          :placeholder="datePlaceholder"
          :picker-options="pickerOptions"
          @change="dateChange"
        />
        <mk-select
          v-model="title"
          class="select-item"
          filterable
          clearable
          remote
          :remote-method="querySearchAsync"
          placeholder="搜索姓名"
          width="150"
          :loading="isFetchData"
        >
          <mk-option
            v-for="item in nameOptions"
            :key="item._id"
            :label="item.name"
            :value="item._id"
          >
          </mk-option>
        </mk-select>
        <div class="btn-group">
          <mk-button-biz
            class="search-btn"
            icon="el-icon-search"
            type="primary"
            @click="search"
          >
            搜索
          </mk-button-biz>
          <mk-button-biz
            width="64px"
            class="reset-btn"
            @click="reset"
          >
            重置
          </mk-button-biz>
        </div>
      </div>
      <div>
        <mk-button-biz
          :loading="loading"
          type="primary"
          @click="exportXls"
        >
          导出
        </mk-button-biz>
      </div>
    </div>
    <div class="list">
      <mk-table
        :data="list"
        height="100%"
      >
        <mk-table-column
          label="头像"
          width="50"
        >
          <template v-slot="scope">
            <img
              v-if="scope.row.avatarUrl"
              class="avatarUrl"
              :src="scope.row.avatarUrl"
            >
            <img
              v-else
              class="avatarUrl"
              src="@/assets/images/user.png"
            >
          </template>
        </mk-table-column>
        <mk-table-column
          prop="userName"
          label="姓名"
          min-width="160"
        />
        <mk-table-column
          label="签到次数"
          prop="signInCount"
          min-width="80"
        />
        <mk-table-column
          label="日志提交次数"
          prop="logCount"
          min-width="120"
        />
        <mk-table-column
          label="任务完成次数"
          prop="cptCount"
          min-width="120"
        />
        <mk-table-column
          label="浏览量（PV）"
          prop="pv"
          min-width="120"
        />
        <mk-table-column
          label="浏览人数（UV）"
          prop="uv"
          min-width="130"
        />
        <mk-table-column
          label="被转发次数"
          prop="shareCount"
          min-width="120"
        />
        <mk-table-column
          label="操作"
          width="80"
          fixed="right"
        >
          <template v-slot="scope">
            <mk-button-biz
              type="text"
              @click="getSaleDetail(scope.row)"
            >
              详情
            </mk-button-biz>
          </template>
        </mk-table-column>
      </mk-table>
    </div>
    <div class="handle-page">
      <!-- <div class="total-info">
        共{{ total }}条
      </div> -->
      <div class="page-info">
        <mk-pagination
          class="pagination"
          :current-page.sync="page"
          :page-size="10"
          layout="total, prev, pager, next, jumper"
          :total="total"
          @current-change="handleCurrentChange"
        >
        </mk-pagination>
        <!-- <span class="page-tip">10条/页</span>
        <div class="jump">
          跳至
          <input
            v-model="nowPage"
            type="number"
            @keyup.enter="updatePage"
          />
          页
        </div> -->
      </div>
    </div>
    <sale-detail
      v-if="show"
      :user-info="saleInfo"
      :show="show"
      @cancel="cancel"
    ></sale-detail>
  </div>
</template>
<script>
import dayjs from 'dayjs'
import saleDetail from './components/sale-detail.vue'
import { BIZAPIS } from '../../../api'
export default {
  components: {
    saleDetail
  },
  data () {
    return {
      dayUnits: [
        {
          label: '按月统计',
          value: 0
        },
        {
          label: '按周统计',
          value: 1
        },
        {
          label: '按日统计',
          value: 2
        }
      ],
      dayUnitIndex: 0,
      loading: false,
      date: '',
      title: '',
      page: 1,
      nowPage: 1,
      total: 0,
      list: [],
      show: false,
      saleInfo: {},
      nameOptions: [],
      isFetchData: false
    }
  },
  computed: {
    dayUnitType () {
      let arr = ['month', 'week', 'date']
      return arr[this.dayUnitIndex]
    },
    dateFormat () {
      let arr = ['yyyy-MM', 'yyyy-MM-dd 开始，第 WW 周', 'yyyy-MM-dd']
      return arr[this.dayUnitIndex]
    },
    valueFormat () {
      let arr = ['yyyy-MM', 'yyyy-MM-dd', 'yyyy-MM-dd']
      return arr[this.dayUnitIndex]
    },
    datePlaceholder () {
      let arr = ['选择月', '选择周，周一为开始日', '选择日']
      return arr[this.dayUnitIndex]
    },
    pickerOptions () {
      let arr = [{}, { firstDayOfWeek: 1 }, {}]
      return arr[this.dayUnitIndex]
    }
  },
  watch: {
    dayUnitIndex () {
      this.date = ''
    }
  },
  created () {
    this.getList()
  },
  methods: {
    dateChange () {
      if (this.dayUnitIndex === 1) {
        this.date = dayjs(
          new Date(new Date(this.date).getTime() - 24 * 60 * 60 * 1000)
        ).format('YYYY-MM-DD')
      }
    },
    cancel () {
      this.show = false
    },
    search () {
      // 搜索
      this.page = 1
      this.nowPage = 1
      this.getList()
    },
    reset () {
      // 重置
      this.dayUnitIndex = 0
      this.date = ''
      this.title = ''
    },
    async exportXls () {
      this.loading = true
      let metas = {}
      if (this.title) {
        metas['userId'] = this.title
      } else {
        delete metas['userId']
      }
      let date = this.date
      if (this.dayUnitIndex === 1) {
        let time = new Date(this.date).getTime() + 6 * 24 * 60 * 60 * 1000
        date = dayjs(
          new Date(new Date(this.date).getTime() + 6 * 24 * 60 * 60 * 1000)
        ).format('YYYY-MM-DD')
      }
      if (this.date) {
        let arr = [
          {
            month: date
          },
          {
            week: date
          },
          {
            day: date
          }
        ]
        let obj = arr[this.dayUnitIndex]
        metas = {
          ...obj,
          ...metas
        }
      } else {
        delete metas['month']
        delete metas['day']
        delete metas['week']
      }
      const res = await BIZAPIS.ExportApi.exportYqfPerformanceGet(metas)
      if (res.success) {
        this.util.download({
          href: res.data
        })
        this.loading = false
      } else {
        this.loading = false
      }
    },
    async querySearchAsync (str) {
      if (str) {
        this.isFetchData = true
        // const res = await BIZAPIS.SalesApi.yqfSalesManageListPost({
        //   page: 1,
        //   name: str
        // })
        const res = await BIZAPIS.SalesApi.yqfSalesManageMatchGet({
          name: str
        })
        if (res.success) {
          this.isFetchData = false
          this.nameOptions = res.data.data
        }
      } else {
        this.isFetchData = false
        this.nameOptions = []
      }
    },
    async getList () {
      let metas = {
        page: this.page,
        pageSize: 10
      }
      if (this.title) {
        metas['userId'] = this.title
      } else {
        delete metas['userId']
      }
      let date = this.date
      if (this.dayUnitIndex === 1) {
        let time = new Date(this.date).getTime() + 6 * 24 * 60 * 60 * 1000
        date = dayjs(
          new Date(new Date(this.date).getTime() + 6 * 24 * 60 * 60 * 1000)
        ).format('YYYY-MM-DD')
      }
      if (this.date) {
        let arr = [
          {
            month: date
          },
          {
            week: date
          },
          {
            day: date
          }
        ]
        let obj = arr[this.dayUnitIndex]
        metas = {
          ...obj,
          ...metas
        }
      } else {
        delete metas['month']
        delete metas['day']
        delete metas['week']
      }
      const res = await BIZAPIS.PerformanceApi.yqfPerformanceGet(metas)
      if (res.success) {
        this.list = res.data.data
        this.total = res.data.total
      }
    },
    handleCurrentChange (e) {
      this.nowPage = e
      this.page = e
      this.getList()
    },
    updatePage (e) {
      if (Number(this.nowPage) < 1) {
        this.nowPage = 1
        this.page = 1
      } else {
        if (Math.ceil(this.total / 10) <= Number(this.nowPage)) {
          this.nowPage = Math.ceil(this.total / 10)
        }
        this.page = Number(this.nowPage)
      }
      this.getList()
    },
    getSaleDetail (data) {
      this.show = true
      this.saleInfo = {
        updateTime: data.updateTime,
        userId: data.userId,
        ...data.user
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.statistical-performance {
  display: flex;
  flex-direction: column;
  height: 100%;
  // min-width: 1000px;

  /deep/ .today {
    .cell {
      color: #000 !important;
    }
  }

  /deep/ .el-date-editor.el-input {
    // width: 160px;
    width: 230px;

    input {
      line-height: 32px;
      height: 32px;
    }

    .el-input--prefix .el-input__inner {
      line-height: 32px;
      height: 32px;
    }

    .el-input__prefix {
      .el-icon-date {
        line-height: 32px;
      }
    }

    .el-input__suffix-inner {
      .el-input__icon {
        line-height: 32px !important;
      }
    }
  }

  /deep/ .el-range-separator {
    line-height: 24px;
  }

  /deep/ .el-range__icon {
    line-height: 24px;
  }

  /deep/ .el-range__close-icon {
    line-height: 24px;
  }

  /deep/ .el-icon-circle-close {
    line-height: 24px;
  }

  .handle-header {
    width: calc(100% - 40px);
    margin: 0 auto;
    margin-top: 20px;
    margin-bottom: 20px;
    flex-shrink: 0;
    display: flex;
    justify-content: space-between;
    align-items: center;

    .select-item {
      margin-right: 10px;
    }

    /deep/ .search-btn {
      padding: 0 14px !important;
      border-radius: 4px;

      .el-icon-search {
        font-size: 14px;
      }

      span {
        font-size: 13px;
        margin-left: 4px;
      }
    }

    /deep/ .reset-btn {
      span {
        font-size: 13px;
      }
    }
  }

  .list {
    width: calc(100% - 40px);
    margin: 0 auto;
    height: 100%;
    overflow: auto;

    .avatarUrl {
      display: block;
      width: 26px;
      height: 26px;
      border-radius: 2px;
    }
  }

  .handle-page {
    width: calc(100% - 40px);
    margin: 0 auto;
    display: flex;
    justify-content: flex-end;
    align-items: center;
    padding: 24px 0 28px 0;

    .total-info {
      font-size: 13px;
      color: #6d7278;
      margin-left: 10px;
    }

    .page-info {
      display: flex;
      align-items: center;
      justify-content: flex-end;

      // /deep/ .pagination {
      //   font-size: 13px;
      //   display: flex;
      //   align-items: center;
      //   margin-top: 0;

      //   .btn-prev {
      //     background: none;
      //     width: 0;
      //     height: 0;
      //     border-top: 6px solid transparent;
      //     border-bottom: 6px solid transparent;
      //     border-right: 6px solid #595959;

      //     .el-icon-arrow-left {
      //       display: none;
      //     }
      //   }

      //   .btn-prev:disabled {
      //     border-right: 6px solid #bfbfbf;
      //   }

      //   .btn-next {
      //     background: none;
      //     width: 0;
      //     height: 0;
      //     border-top: 6px solid transparent;
      //     border-bottom: 6px solid transparent;
      //     border-left: 6px solid #595959;

      //     .el-icon-arrow-right {
      //       display: none;
      //     }
      //   }

      //   .btn-next:disabled {
      //     border-left: 6px solid #bfbfbf;
      //   }

      //   .el-pager {
      //     margin: 0 8px;

      //     li {
      //       min-width: 30px;
      //       height: 24px;
      //       line-height: 24px;
      //     }
      //   }
      // }

      .page-tip {
        font-size: 14px;
        color: #595959;
        margin-left: -16px;
      }

      .jump {
        font-size: 13px;
        color: #595959;
        margin-left: 88px;

        input {
          width: 58px;
          height: 24px;
          padding: 0 12px;
          box-sizing: border-box;
          border: 1px solid #d9d9d9;
          border-radius: 2px;
        }

        input::-webkit-outer-spin-button,
        input::-webkit-inner-spin-button {
          -webkit-appearance: none;
        }

        input[type='number'] {
          -moz-appearance: textfield;
        }
      }
    }
  }
}
</style>
